import React, { Dispatch, SetStateAction } from 'react';
import { Button, Modal } from '@ixicare/ui';
import { t } from '~i18n';

interface DeleteSiteConfirmationModalProps {
  onDelete: (uuid: string) => void;
  loading: boolean;
  setShowModal: Dispatch<SetStateAction<boolean>>;
  siteUuid: string;
}

const DeleteSiteConfirmationModal: React.FC<DeleteSiteConfirmationModalProps> = ({
  onDelete,
  loading,
  setShowModal,
  siteUuid,
}) => {
  if (!setShowModal) {
    return null;
  }
  return (
    <Modal style={{ maxWidth: 450 }}>
      <h3 className="text-center mb-30">{t('siteSettings.deleteSiteModal.description')}</h3>
      <Button
        className="mb-15 error"
        disabled={loading}
        loading={loading}
        isBlock
        buttonType="error"
        type="button"
        onClick={() => onDelete(siteUuid)}
      >
        {t('siteSettings.deleteSiteModal.delete')}
      </Button>
      <Button onClick={() => setShowModal(false)} disabled={loading} isBlock buttonType="link">
        {t('global.cancel')}
      </Button>
    </Modal>
  );
};

export default DeleteSiteConfirmationModal;
